module.exports = __webpack_public_path__ + "img/tzrql.219ed705.jpg";